<new-survey *ngIf="ndg" [ndg]="ndg"></new-survey>
